import { render, staticRenderFns } from "./VehiclePartDamage.vue?vue&type=template&id=63265563&"
import script from "./VehiclePartDamage.vue?vue&type=script&lang=js&"
export * from "./VehiclePartDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports